// DCL-172: read-only preview of a sample referral, opened from the empty
// History list placeholders. Shows a watermarked screenshot of the referral page.
angular.module('modals')
    .controller('DemoReferralModalController', ['$scope', '$uibModalInstance', 'demoReferral',
        function ($scope, $uibModalInstance, demoReferral) {
            $scope.referral = demoReferral;

            $scope.createReferral = function () {
                $uibModalInstance.close('create');
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }]);
